import React, { useEffect } from "react";
import { Drawer } from "../../../components/Drawer";
import { TaskDetails } from "../../../components/tasks/TaskDetails";
import { useTranslation } from "react-i18next";
import { useDrawersContext } from "../drawers-context";
import { BaseTask } from "../../../model/task/Task";
import { useAppDispatch, useAppSelector } from "../../../redux/store";
import { taskActions } from "../../../redux/task/task.slice";
import { userSliceSelectors } from "../../../redux/user/user.selector";

export const TaskReadDrawer: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { task, setTask, taskReadVisible, setTaskReadVisible } =
    useDrawersContext();

  const userId = useAppSelector(userSliceSelectors.selectLoggedInUserId)!;

  useEffect(() => {
    if (task?._id && taskReadVisible) {
      const fetchTask = async () => {
        const _task = await dispatch(
          taskActions.getTask({ taskId: task._id!, userId, kind: task.kind }),
        ).unwrap();
        if (_task) {
          setTask(_task);
        }
      };

      fetchTask();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [task?._id, taskReadVisible]);

  return (
    <Drawer
      title={t("common.task_preview")}
      open={taskReadVisible}
      onClose={() => setTaskReadVisible(false)}
      size="large"
      key={task?._id}
      destroyOnHidden
    >
      <TaskDetails task={task as BaseTask} />
    </Drawer>
  );
};
